import type { Selector } from 'core/core.selectors';

export const getIsLogged: Selector<boolean> = state => state.uiState.auth.isLogged;

export const selectShowScoutingScorePermission: Selector<boolean | undefined> = state =>
  state.uiState.auth.permissionFlags?.showScoutingScore?.value;
